export default __webpack_public_path__ + "static/media/checkmark-circle.8878d049.svg";